import { Action, createReducer, on } from '@ngrx/store';

import {
  fetchOptionForUpsellAction,
  fetchUpsellOptionsForDesktopAction,
  fetchUpsellOptionsForDesktopErrorAction,
  fetchUpsellOptionsForDesktopSuccessAction,
  fetchPackageUpsellOptionsErrorAction,
  fetchPackageUpsellOptionsSuccessAction,
  fetchFlightsOptionForPackageUpsellAction,
  fetchFlightsOptionForPackageUpsellForDesktopAction,
  fetchUpsellOptionsForPackageUpsellForDesktopAction
} from '@upsell/store/actions/upsell.actions';

export const initialState = false;

const featureReducer = createReducer(
  initialState,
  on(fetchOptionForUpsellAction, () => true),
  on(fetchUpsellOptionsForDesktopAction, () => true),
  on(fetchUpsellOptionsForDesktopSuccessAction, () => false),
  on(fetchUpsellOptionsForDesktopErrorAction, () => false),
  on(fetchFlightsOptionForPackageUpsellAction, () => true),
  on(fetchPackageUpsellOptionsSuccessAction, () => false),
  on(fetchPackageUpsellOptionsErrorAction, () => false),
  on(fetchFlightsOptionForPackageUpsellForDesktopAction, () => true),
  on(fetchUpsellOptionsForPackageUpsellForDesktopAction, () => true)
);

export const isLoadingUpsellForDesktopReducer = (state: boolean, action: Action): boolean => {
  return featureReducer(state, action);
};
